(() => {
  const runAbra = () => window.Abra?.render?.();
  const scheduleRenders = (delays) => {
    runAbra();
    delays.forEach(delay => setTimeout(runAbra, delay));
  };

  const checkElement = (element, className) =>
    element.classList?.contains(className) || element.querySelector?.(`.${className}`);

  document.addEventListener('slide-panel-open', () => scheduleRenders([300, 800, 1500, 2500]));

  new MutationObserver(mutations => {
    mutations.forEach(({ type, target, addedNodes }) => {
      if (type === 'childList' && addedNodes.length > 0) {
        if (checkElement(target, 'slide-panel__body-container')) {
          scheduleRenders([200, 500, 1000]);
        }

        [...addedNodes].forEach(node => {
          if (node.nodeType === 1 && checkElement(node, 'product-details__inner')) {
            scheduleRenders([300, 800, 1500, 2500]);
          }
        });
      }
    });
  }).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('click', e => {
    if (e.target.closest('.js-toggle-quick-shop, [data-target="quick-shop"]')) {
      [1000, 2500, 4000].forEach(delay => setTimeout(runAbra, delay));
    }
  });
})();

(() => {
  const isCartPage = () => /\/cart\/?$/.test(location.pathname.toLowerCase());
  if (!isCartPage()) return;

  const fireEvents = (delay) => {
    setTimeout(() => {
      document.dispatchEvent(new Event('main-cart::refresh'));
      document.dispatchEvent(new Event('cart::add'));
    }, delay);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => fireEvents(1000), { once: true });
  } else {
    fireEvents(800);
  }

  document.addEventListener('click', (e) => {
    if (
      e.target.closest('.js-plus') ||
      e.target.closest('.js-minus') ||
      e.target.closest('.main-cart__line-item__remove')
    ) {
      fireEvents(500);
      fireEvents(800);
    }
  });
})();
